import { useState } from "react";
import { Menu, X, ArrowRight } from "lucide-react";
import { Logo } from "./Logo";
import { scrollToSection } from "../lib/scroll";

const LINKS = [
    { id: "services", label: "Services" },
    { id: "system", label: "360° System" },
    { id: "why", label: "Why 24queue" },
    { id: "results", label: "Results" },
];

export const Navbar = ({ onOpenModal }) => {
    const [open, setOpen] = useState(false);

    const go = (id) => {
        setOpen(false);
        scrollToSection(id);
    };

    return (
        <header data-testid="navbar" className="fixed inset-x-0 top-0 z-50 border-b-2 border-ink/10 bg-paper/85 backdrop-blur-md">
            <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-3 lg:px-8">
                <Logo />
                <nav className="hidden items-center gap-8 md:flex">
                    {LINKS.map((l) => (
                        <button
                            key={l.id}
                            data-testid={`nav-link-${l.id}`}
                            onClick={() => go(l.id)}
                            className="font-mono text-xs uppercase tracking-[0.18em] text-ink/70 transition-colors duration-300 hover:text-inkblue"
                        >
                            {l.label}
                        </button>
                    ))}
                </nav>
                <div className="flex items-center gap-3">
                    <button
                        data-testid="nav-cta-button"
                        onClick={onOpenModal}
                        className="btn-primary hidden items-center gap-2 border-2 border-ink bg-ink px-4 py-2 font-mono text-xs font-bold uppercase tracking-wider text-paper md:flex"
                    >
                        Build My Queue <ArrowRight size={14} />
                    </button>
                    <button
                        data-testid="nav-mobile-menu-button"
                        onClick={() => setOpen(!open)}
                        className="border-2 border-ink/20 p-2 text-ink md:hidden"
                        aria-label="Toggle menu"
                    >
                        {open ? <X size={18} /> : <Menu size={18} />}
                    </button>
                </div>
            </div>
            {open && (
                <div data-testid="nav-mobile-menu" className="border-t-2 border-ink/10 bg-paper px-5 py-4 md:hidden">
                    <div className="flex flex-col gap-4">
                        {LINKS.map((l) => (
                            <button
                                key={l.id}
                                data-testid={`nav-mobile-link-${l.id}`}
                                onClick={() => go(l.id)}
                                className="text-left font-mono text-sm uppercase tracking-[0.18em] text-ink/80"
                            >
                                {l.label}
                            </button>
                        ))}
                        <button
                            data-testid="nav-mobile-cta-button"
                            onClick={() => { setOpen(false); onOpenModal(); }}
                            className="mt-2 flex items-center justify-center gap-2 border-2 border-ink bg-ink px-4 py-3 font-mono text-xs font-bold uppercase tracking-wider text-paper"
                        >
                            Build My Queue <ArrowRight size={14} />
                        </button>
                    </div>
                </div>
            )}
        </header>
    );
};
